import Obfuscator, { obfuscateText } from "./Obfuscator";

export default Obfuscator;

export { Obfuscator, obfuscateText };
